import { Component, Input } from '@angular/core';

export interface LegendItem {
  icon: string;
  text: string;
  boldWord?: string;
}

@Component({
  selector: 'app-table-legend',
  templateUrl: './table-legend.component.html',
  styleUrls: ['./table-legend.component.scss'],
})
export class TableLegendComponent {
  @Input() items: LegendItem[] = [];
}
